import React, { useEffect } from "react";
import { Grid, IconButton, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CustomButton, icon, IconComponent, SearchInput } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import { setUpdateLicenceManagement } from "../../../../../common/slice";
import UserDrawer from "../../user-drawer/UserDrawer";
import FormBlockedUser from "../../form/FormBlockedUser";

export default function ViewSearch() {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const [searchValue, setValueSearch] = React.useState(licenceManagementStore.searchCompaniesByUser);
	const [openDrawer, setOpenDrawer] = React.useState(false);

	const dispatch = useDispatch();
	const handelSearchInputProps = () => {
		dispatch(setUpdateLicenceManagement({ searchCompaniesByUser: searchValue }));
	};
	const handelSearchInput = (e) => {
		setValueSearch(e.target.value);
		if (e.target.value === "") {
			dispatch(setUpdateLicenceManagement({ searchCompaniesByUser: "" }));
		}
	};

	const handelCloseDrawer = () => {
		setOpenDrawer(false);
		dispatch(setUpdateLicenceManagement({ refresh: true }));
	};
	const handelOpenDrawer = () => {
		dispatch(setUpdateLicenceManagement({ refresh: false }));
		setOpenDrawer(true);
	};
	useEffect(() => {
		setValueSearch(licenceManagementStore.searchCompaniesByUser);
	}, [licenceManagementStore.searchCompaniesByUser]);

	return (
		<Grid container item direction="row" justifyContent="space-between" md={12}>
			<SearchInput
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<IconButton onClick={handelSearchInputProps}>
								<IconComponent color="var(--grey-400)" icon={icon.faSearch} />
							</IconButton>
						</InputAdornment>
					),
				}}
				placeholder={translate("license-management.user-search.search-territory")}
				size="small"
				value={searchValue}
				variant="outlined"
				onChange={(e) => {
					handelSearchInput(e);
				}}
				onKeyDown={(event) => {
					if (event.key === "Enter") {
						handelSearchInputProps();
					}
				}}
			/>
			<CustomButton
				color="primary"
				size="md"
				startIcon={icon.faGear}
				variant="contained"
				onClick={handelOpenDrawer}
			>
				{translate("common:btn.edit")}
			</CustomButton>
			<Grid container>
				<UserDrawer
					hiddenAction
					childrens={<FormBlockedUser />}
					closeDrawer={handelCloseDrawer}
					open={openDrawer}
					title={translate("license-management.dialog.edit-access-territory")}
				/>
			</Grid>
		</Grid>
	);
}
